import { FC } from 'react'

import { ArticleContentSection } from 'api'
import { ARTICLE_CONTENT } from 'utils/routes'

import { ComponentLayout } from './component-layout'

interface ContentProps {
  content: ArticleContentSection[]
}

export const Content: FC<ContentProps> = ({ content }) => {
  return (
    <article id={ARTICLE_CONTENT}>
      {content.map((componentData) => (
        <ComponentLayout
          {...componentData}
          key={`${componentData.id}-${componentData.__component}`}
        />
      ))}
    </article>
  )
}
